<template>
  <Breadcrumbs />
  <DynamicContent
    id="city-overview-content-introduction"
    class="container dynamic-content"
    :html="content?.introductionBlock"
  />
  <CitiesGrid />

  <DynamicContent
    id="city-overview-content-similar"
    class="container dynamic-content"
    :html="content?.similarBlock"
  />
  <DynamicContent
    id="city-overview-content-timed"
    class="container dynamic-content"
    :html="content?.timedBlock"
  />
  <DynamicContent
    id="city-overview-content-offers"
    class="container dynamic-content"
    :html="content?.offersBlock"
  />

</template>

<script setup lang="ts">
import { useWebsitePageQuery } from '~/graphql/generated';

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/steden",
    fr: "/villes",
    nl: "/steden",
  },
});

// Set the (optional) page content blocks
const path = useRoute().path;

const { t } = useI18n();

useSeoMeta({
  title: t("cities.title"),
  description: t("cities.meta-description"),
  ogDescription: t("cities.meta-description"),
});

const { websitePagePath } = useWebsitePagePath(path);

const page = await useWebsitePageQuery({
  variables: websitePagePath,
});

const content = useDynamicContent(page.data);
</script>

<style lang="scss" scoped></style>
